import clsx from 'clsx';
import React from 'react';

import AnchorActivityItem from '../AnchorActivityItem/AnchorActivityItem';

const MovedItem = (props) => {
  const { folderName, filename, onClickFile } = props;
  const actionTypeLabel = ` moved `;

  return (
    <React.Fragment>
      <AnchorActivityItem
        filename={filename}
        actionTypeLabel={actionTypeLabel}
        onClickFile={onClickFile}
      />
      <span className={clsx('tw-text-cfo-black')}> to </span>
      <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
        {folderName}
      </strong>
    </React.Fragment>
  );
};

export default MovedItem;
